import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.jsx';
import reportWebVitals from './reportWebVitals.js';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import 'semantic-ui-css/semantic.min.css'
import './Utils/i18n.jsx'; // Path to your i18n.jsx
import { EnvironmentProvider } from './Context/EnvironmentContext.jsx'
import ErrorPage from './Utils/ErrorPage.jsx';
import posthog from 'posthog-js';
import { PostHogProvider } from '@posthog/react';

// Initialize PostHog before rendering
const posthogOptions = {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
  defaults: '2026-01-30',
};

posthog.init(import.meta.env.VITE_PUBLIC_POSTHOG_KEY, posthogOptions);

const router = createBrowserRouter([
  {
    path: "/*",
    errorElement: <ErrorPage />,
    element:
      <div style={{ backgroundColor: "#00201f", width: "100%", height: "100%" }}>
        <HelmetProvider>
          <EnvironmentProvider>
            <App />
          </EnvironmentProvider>
        </HelmetProvider>
      </div>,
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <PostHogProvider client={posthog}>
      <RouterProvider router={router} />
    </PostHogProvider>
  </React.StrictMode>
);

window.onbeforeunload = (event) => {
  // Get the current path
  const currentPath = window.location.pathname;

  // Only show warning for Create and Story pages
  if (currentPath.startsWith('/Create') || currentPath.startsWith('/Story')) {
    const e = event || window.event;
    e.preventDefault();
    if (e) {
      e.returnValue = '';
    }
    return '';
  }

  // Don't show warning for other pages
  return undefined;
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();